export default __webpack_public_path__ + "static/media/w.81958304.svg";